"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContactDialog = ContactDialog;
var _DialogContent2 = _interopRequireDefault(require("@mui/material/DialogContent"));
var _Send2 = _interopRequireDefault(require("@mui/icons-material/Send"));
var _CircularProgress2 = _interopRequireDefault(require("@mui/material/CircularProgress"));
var _Close2 = _interopRequireDefault(require("@mui/icons-material/Close"));
var _TextField2 = _interopRequireDefault(require("@mui/material/TextField"));
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _Dialog3 = _interopRequireDefault(require("@mui/material/Dialog"));
var _notistack = require("notistack");
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _services = require("../services");
var _button = require("./button");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ContactDialog({
  Dialog: _Dialog,
  Button: _Button,
  currentUser,
  challenge,
  selectedUsersIds,
  onClose,
  ...props
}) {
  const [message, setMessage] = (0, _react.useState)('');
  const [sending, setSending] = (0, _react.useState)(false);
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const {
    enqueueSnackbar
  } = (0, _notistack.useSnackbar)();
  (0, _react.useEffect)(() => {
    setMessage('');
  }, [props.open]);
  async function handleContact() {
    if (!currentUser || !challenge || !message) return;
    setSending(true);
    try {
      await _services.GeogroupService.sendEmailToParticipants(challenge.id, currentUser.email, selectedUsersIds, message);
      onClose();
      enqueueSnackbar(t('commons.challenge_details.contact_dialog.success'));
    } catch (err) {
      console.error(err);
      enqueueSnackbar(t('commons.challenge_details.contact_dialog.server_error'), {
        variant: 'error'
      });
    }
    setSending(false);
  }
  const Dialog = _Dialog || _Dialog3.default;
  const Button = _Button || _button.Button;
  return /*#__PURE__*/_react.default.createElement(Dialog, _extends({
    fullWidth: true,
    maxWidth: "sm",
    onClose: () => onClose()
  }, props), /*#__PURE__*/_react.default.createElement(_DialogContent2.default, {
    sx: _Dialog ? {
      padding: 0
    } : {}
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    gap: 3
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    gap: 2
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    fontSize: "1.1rem",
    fontWeight: 600
  }, t('commons.challenge_details.contact_dialog.title'))), /*#__PURE__*/_react.default.createElement(_TextField2.default, {
    fullWidth: true,
    multiline: true,
    required: true,
    disabled: sending,
    id: "message",
    label: t('commons.challenge_details.contact_dialog.labels_message'),
    margin: "none",
    name: "message",
    onChange: ({
      currentTarget: {
        value
      }
    }) => setMessage(value),
    rows: 2,
    slotProps: {
      htmlInput: {
        maxLength: 200
      }
    },
    value: message,
    variant: "outlined"
  }), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    gap: 3,
    justifyContent: "flex-end"
  }, /*#__PURE__*/_react.default.createElement(Button, {
    color: "primary",
    disabled: sending,
    onClick: onClose,
    startIcon: /*#__PURE__*/_react.default.createElement(_Close2.default, null),
    variant: "outlined"
  }, t('commons.actions.cancel')), /*#__PURE__*/_react.default.createElement(Button, {
    disabled: sending || !message,
    onClick: handleContact,
    startIcon: sending ? /*#__PURE__*/_react.default.createElement(_CircularProgress2.default, {
      color: "inherit",
      size: 16,
      thickness: 4
    }) : /*#__PURE__*/_react.default.createElement(_Send2.default, null),
    variant: "contained"
  }, t('commons.actions.send'))))));
}